export enum EntityFilterType {
  USER = 'USER',
  PROPERTY = 'PROPERTY',
  ACCOUNT = 'ACCOUNT',
}
